import { createApp } from 'vue'
import App from './App.vue'
import router from './router';
import store from './store'
import './axios/axios'
import VueToast from 'vue-toast-notification';
import VueLoading from 'vue-loading-overlay';
import Shimmer from 'vue3-shimmer';

import 'vue-toast-notification/dist/theme-sugar.css';
import "./assets/css/tailwind.css";
import 'vue-loading-overlay/dist/vue-loading.css';

const app = createApp(App);

app.use(store);
app.use(router);
app.use(VueToast);
app.use(VueLoading);
app.use(Shimmer);

app.mount('#app')